module.exports = __webpack_public_path__ + "static/about-img10-88fcd161fd339de5d9e34c286118cbd0.png";